import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Filter, SearchService } from '@docpath/linces-angular-components';
import { DpSection, HeaderAction, SearchBasicInfo, SearchMode, SearchOptionType, SearchRowInfo } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';

import { Alias } from '../../../alias/models/alias';
import { Dge } from '../../../engines/models/dge';
import { Notification } from '../../models/notification';
import { NotificationOptions } from '../../models/notification-options';
import { FailedJobsService } from '../../services/failed-jobs.service';
import { FailedJobsTableService } from '../table/failed-jobs-table.service';
import { FailedJobsHeaderService } from './failed-jobs-header.service';



@Component({
  selector: 'app-failed-jobs-header',
  templateUrl: './failed-jobs-header.component.html'
})
export class FailedJobsHeaderComponent implements OnChanges, OnInit, OnDestroy {
  @Input() notifications: Notification[] = [];
  @Output() filtersChanged = new EventEmitter<Filter[]>();

  leftActions: HeaderAction[] = [];
  rightActions: HeaderAction[] = [];

  aliasOptions: Alias[] = [];
  dgesOptions: Dge[] = [];
  notificationsResult: Notification[] = [];
  notificationOptions: NotificationOptions;

  showSearch = false;
  private readonly title = 'failed-jobs.title';
  private readonly tooltip = 'failed-jobs.tooltip';
  section = new DpSection({ name: 'failed-jobs', rows: [], header: this.title, tooltip: this.tooltip });
  searchAvailableOptions: SearchRowInfo[] = [
    new SearchRowInfo(true, 'alias', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true),
    new SearchRowInfo(false, 'dge', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true)
  ];
  private filters: Filter[] = [];
  private failedJobsChangedSubscription?: Subscription;
  private failedJobsAliasLoadedSubscription?: Subscription;
  private failedJobsDgesLoadedSubscription?: Subscription;
  private failedJobsLoadedSubscription?: Subscription;


  constructor(
    private readonly failedJobsHeaderService: FailedJobsHeaderService,
    private readonly failedJobsTableService: FailedJobsTableService,
    private readonly failedJobsService: FailedJobsService,
    private readonly searchService: SearchService
  ) {
    this.notificationOptions = new NotificationOptions(this.notificationsResult, this.aliasOptions, this.dgesOptions);
    this.rightActions = this.failedJobsHeaderService.getRightActions(this.notificationOptions);
    const searchAction = this.failedJobsHeaderService.getSearchAction(this.rightActions);

    searchAction.action = () => {
      this.showSearch = !this.showSearch;
    };

  }


  ngOnInit(): void {
    if (!this.failedJobsChangedSubscription) {
      this.failedJobsChangedSubscription = this.failedJobsService.failedJobsChanged.subscribe(() => {
        this.leftActions = [];
      });
    }

    if (!this.failedJobsLoadedSubscription) {
      this.failedJobsLoadedSubscription = this.failedJobsTableService.failedJobsLoaded.subscribe(result => {
        this.notificationsResult = result.notifications as unknown as Notification[];
        this.failedJobsHeaderService.loadAliasOptions();
      });
    }

    
    if (!this.failedJobsAliasLoadedSubscription) {
      this.failedJobsAliasLoadedSubscription = this.failedJobsHeaderService.aliasLoaded.subscribe(result => {
        this.aliasOptions = result;
        this.failedJobsHeaderService.loadDgesOptions();
      });
    }

    if (!this.failedJobsDgesLoadedSubscription) {
      this.failedJobsDgesLoadedSubscription = this.failedJobsHeaderService.dgesLoaded.subscribe(result => {
        this.dgesOptions = result;
        if (this.notificationsResult && this.aliasOptions && this.dgesOptions) {
          this.notificationOptions = new NotificationOptions(this.notificationsResult, this.aliasOptions, this.dgesOptions);
          this.rightActions = this.failedJobsHeaderService.getRightActions(this.notificationOptions);
          const searchAction = this.failedJobsHeaderService.getSearchAction(this.rightActions);

          searchAction.action = () => {
            this.showSearch = !this.showSearch;
          };

          this.failedJobsService.notifyNotificationOptionsLoaded(this.notificationOptions);
        }
      });
    }

  }

  ngOnDestroy(): void {
    if (this.failedJobsChangedSubscription) {
      this.failedJobsChangedSubscription.unsubscribe();
    }
    if (this.failedJobsAliasLoadedSubscription) {
      this.failedJobsAliasLoadedSubscription.unsubscribe();
    }
    if (this.failedJobsDgesLoadedSubscription) {
      this.failedJobsDgesLoadedSubscription.unsubscribe();
    }
    if (this.failedJobsLoadedSubscription) {
      this.failedJobsLoadedSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // eslint-disable-next-line dot-notation
    if (changes['notifications']) {
      this.leftActions = this.failedJobsHeaderService.getLeftActions(this.notifications, this.notificationOptions);
    }
  }

  isSearchVisible(): boolean {
    return this.showSearch;
  }

  clearSearch(): void {
    this.filters = [];
    this.filtersChanged.emit(this.filters);
    this.failedJobsTableService.loadNotifications(this.filters, 1);
    this.leftActions = [];
  }

  sendSearch(currentFilters: Array<SearchBasicInfo>): void {
    this.filters = this.searchService.toFilters(currentFilters);
    this.filtersChanged.emit(this.filters);
    this.failedJobsTableService.loadNotifications(this.filters, 1);
    this.leftActions = [];
  }

  hideSearch(): void {
    this.showSearch = false;
  }
}
